<template>
<div>
  <Author
    v-if="related.length !== 0"
    show-extra="true"
    :id="author.id_str"
    :profileImageUrl="author.profile_image_url_https"
    :location="author.location"
    :description="author.description"
    :followersCount="author.followers_count"
    :name="author.name"
    :screenName="author.screen_name"
  />

  <h1 v-if="related.length === 0">Author "{{$route.params.id}}" not found.</h1>

  <div class="page-container" style="min-height: 0px; max-width: 1000px;">
    <div class="masonry-container" style="margin-bottom: 70px;">
      <Tweet
        v-for="(c, i) in related" 
        :key="`tweet-card-${i}`"

        :id="c.id"
        :likes="c.likes"
        :title="c.title"
        :text="c.tweet.text"
        :createdAt="c.createdAt"
        :is-bot="c.isBot === true"
        :primary-tags="c.primaryTags"
        :secondary-tags="c.secondaryTags"

        :author-id="c.author.id_str"
        :profile-image-url="c.author.profile_image_url_https"
        :location="c.author.location"
        :followers-count="c.author.followers_count"
        :description="c.author.description"
        :name="c.author.name"
        :screen-name="c.author.screen_name"
        :ref="c.ref"
      />
    </div>
  </div>
</div>
</template>

<script>
import firebase from '@/firebase'

import Author from '@/components/Author.vue'
import Tweet from '@/components/Tweet.vue'

export default {
    components: {
        Author,
        Tweet,
    },

    mounted() {
      this.$store.state.showLoading = true
      this.getAuthor()
    },

    data(){
       return {
          related: [],
          author: null,
       }
    },

    methods: {
      async getAuthor() {
          const snap = await firebase.firestore.collection('threads2')
            .where('author.id_str', '==', this.$route.params.id)
            .get()

          if(snap.empty){
            this.related = []

            this.$store.state.showLoading = false

            return
          }

          const author = snap.docs[0].data().author
          this.author = author

          this.related = snap.docs
            .map(x => {
              const m = x.data()
              m.id = x.id
              m.ref = x.ref
              return m
            })

          this.$store.state.showLoading = false
        },
    }
}
</script>

<style scoped>
h1 {
  text-align: center;
}
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .page-container{
    padding: 0 0.5rem;
  }
  .masonry-container{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    align-items: center;
    margin-top: 20px;
  }
}
.masonry-container{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-top: 20px;
}
</style>